/**
 * The build's environment, read through ONE reference (2026-09-26).
 *
 * The browser build defines `process.env` as a single object holding every
 * variable the build carries: NODE_ENV, PUBLIC_URL and each REACT_APP_* that
 * was set (react-scripts' config/env.js). A read of a variable the build SET
 * compiles to its value. A read of one the build did NOT set compiles to that
 * whole object followed by the name — `{NODE_ENV:"production",…}.REACT_APP_X` —
 * because the substitution cannot know the name is absent. So every read of an
 * unset flag carried a full copy of the environment. Measured on 2026-09-26:
 * the chat engine held 34 copies of a 652-byte object on a build with CI's
 * variables (43 locally), about 460 bytes compressed; production's build sets
 * 19 variables, so each copy is larger there.
 *
 * Reading through here keeps one copy: `process.env` appears once, below.
 *
 * `process.env[name]` is safe in the browser: the build replaces the
 * `process.env` expression itself, so the object is there to index. What is
 * NOT safe, and never used here, is `typeof process`: there is no `process`
 * global in the browser, and a `typeof process` guard left an allowlist
 * silently empty in production on 2026-07-15
 * (tests/threadChoicePanel/enablement.test.ts). The belief that grew from that
 * incident — "only a direct `process.env.REACT_APP_*` reference is inlined" —
 * is true of the guard, not of the object: this module is the proof, pinned by
 * tests/landing/theBuildEnvironmentIsReadOnce.test.ts and by the bundle budget,
 * which fails when the chat engine carries the environment more than once.
 *
 * Under jest, `process.env` is Node's live environment, so a test that sets a
 * variable before calling a reader still sees it.
 */
export type BuildEnv = Readonly<Record<string, string | undefined>>;

/** The build's environment: every variable the build set; any other name reads as undefined. */
export function buildEnv(): BuildEnv {
  return process.env as BuildEnv;
}
